import { CloseOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { ConfigProvider, Drawer, Empty, Spin, Typography, message } from 'antd';
import { ReactComponent as Download } from "asset/mobile/download_m.svg";
import { ReactComponent as EmptyImg } from "asset/mobile/empty_m.svg";
import axios from 'axios';
import style from "css/address.module.css";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function AddressUploadPopup({ isOpen, closePopup }) {
    const { t } = useTranslation();
    const [isUploading, setIsUploading] = useState(false);
    const [isTemplateDownloading, setIsTemplateDownloading] = useState(false);

    const closeHandler = () => {
        closePopup();
    }

    const downloadExcelTemplate = () => {
        setIsTemplateDownloading(true);
        const config = {
            responseType: "blob",
        };
        axios.get("/address/excel", config).then((res) => {
            if (res.status === 200) {
                const url = window.URL.createObjectURL(
                    new Blob([res.data], { type: res.headers["content-type"] })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", t("FILE_NAME.EXCEL.CONTACT_FORM"));
                document.body.appendChild(link);
                link.click();
            }
        }).finally(() => setIsTemplateDownloading(false));
    }

    const uploadExcel = (e) => {
        setIsUploading(true);
        const excelInfo = e.target.files[0];
        const formData = new FormData();
        formData.append("file", excelInfo);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        };
        axios.post("/address/upload", formData, config)
            .then((res) => {
                if (res.status === 200) {
                    e.target.value = '';
                    message.success(t("MESSAGE.CONTACT_UPLOAD_COMPLETE", { FILE_NAME: excelInfo.name }));
                    closeHandler();
                }
            })
            .catch(err => {
                message.error(t("MESSAGE.CONTACT_UPLOAD_FAILED", { FILE_NAME: excelInfo.name }));
            })
            .finally(() => {
                setIsUploading(false);
            })
    };

    // 팝업에서 swipe down하여 팝업 닫기
    useEffect(() => {
        if (isOpen) {
            const pStart = { x: 0, y: 0 };
            const pCurrent = { x: 0, y: 0 };


            function swipeStart(e) {
                let touch = e.targetTouches ? e.targetTouches[0] : e;
                pStart.x = touch.screenX;
                pStart.y = touch.screenY;
            }


            function swipe(e) {
                let touch = e.changedTouches ? e.changedTouches[0] : e;
                pCurrent.x = touch.screenX;
                pCurrent.y = touch.screenY;

                let changeY = Math.max(0, pCurrent.y - pStart.y);
                if (changeY > 100) {
                    console.log("close popup")
                    closeHandler();
                }
            }

            document.addEventListener("touchstart", swipeStart, false);
            document.addEventListener("touchmove", swipe, false);

            return () => {
                document.removeEventListener("touchstart", swipeStart);
                document.removeEventListener("touchmove", swipe);
            }
        }
    }, [isOpen]);

    return (
        <Drawer
            className='popup_bot'
            placement='bottom'
            // size='large'
            open={isOpen}
            onClose={closeHandler}
            closable={false}
            maskClosable={false}
            height="100vh"
        >
            <div className={style.addr_popup_container}>
                <div className={style.addr_popup_header}>
                    <div className={style.popup_title}>{t("LABEL.TITLE.CONTACT_UPLOAD")}</div>
                    <CloseOutlined className={style.popup_close} onClick={closeHandler} />
                </div>
                <div className={style.addr_popup_content} style={{ display: "flex", flexDirection: 'column', justifyContent: "center" }}>
                    <label htmlFor='upload-input'>
                        <Empty
                            // image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                            // image={<EmptyImg />}
                            image={process.env.REACT_APP_CLIENT_URL + "img/mobile/address/addr_upload_m.png"}
                            styles={{
                                image: {
                                    height: 100,
                                    // ImageBackground: "#fff"
                                },
                            }}
                            style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                            // imageStyle={{ filter: "#fff" }}
                            description={
                                <>
                                    {isUploading ?
                                        <Spin />
                                        : <ConfigProvider
                                            theme={{
                                                components: {
                                                    Typography: {
                                                        colorText: "#1cb691",
                                                    }
                                                }
                                            }}
                                        >
                                            <Typography.Text className={style.addr_upload_typoTxt}>
                                                <CloudUploadOutlined style={{ color: "#1cb691", marginRight: "5.4px", fontSize: "19px" }} />
                                                {t("LABEL.TITLE.CONTACT_UPLOAD")}
                                                <input
                                                    type='file'
                                                    id='upload-input'
                                                    accept='.xlsx'
                                                    onChange={uploadExcel}
                                                    style={{ display: "none" }}
                                                />
                                            </Typography.Text>
                                        </ConfigProvider>
                                    }
                                    {/* <div className={style.addr_upload_msg}>{t("MESSAGE.UPLOAD_CONTACT_FILE")}</div> */}
                                    <div className={style.addr_upload_msg} dangerouslySetInnerHTML={{ __html: t("MESSAGE.UPLOAD_CONTACT_FILE_M") }} />
                                </>
                            }
                        // onClick={() => console.log("click")}
                        >
                            <button
                                className={style.addr_downloadBtn}
                                onClick={downloadExcelTemplate}
                            >
                                <Download />
                                {isTemplateDownloading ? <Spin /> : t("BTN.DOWNLOAD_FORM")}
                            </button>
                        </Empty>
                    </label>
                </div>
                <div className={style.addr_popup_footer}>
                    <button
                        className={style.saveBtn}
                        style={{ width: "100%" }}
                        onClick={closeHandler}
                    >
                        {
                            // isLoading
                            //     ? <ConfigProvider
                            //         theme={{
                            //             components: {
                            //                 Spin: {
                            //                     colorPrimary: "#fff"
                            //                 }
                            //             }
                            //         }}
                            //     >
                            //         <Spin />
                            //     </ConfigProvider>
                            // :
                            t("BTN.COMPLETE")
                        }
                    </button>
                </div>
            </div>
        </Drawer>
    )
}

export default AddressUploadPopup
